// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rp-0";